import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { I18nModule, ConfigModule, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { GuestTrackingService } from './guest-tracking.service'
import { OrderTrackingGuestComponent } from './order-tracking-guest/order-tracking-guest.component'
import { QuoteTrackingGuestComponent } from './quote-tracking-guest/quote-tracking-guest.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [OrderTrackingGuestComponent, QuoteTrackingGuestComponent],
  imports: [
    CommonModule,
    SpinnerModule,
    I18nModule,
    ReactiveFormsModule,
    RouterModule,
    I18nModule,
    NgSelectModule,
    UrlModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['guesttrack'],
        },
      },
    }),
  ],
  providers: [GuestTrackingService],
})
export class GuestTrackingModule {}
